import * as React from "react";
import {cx} from "emotion";

import "./applied-copay.scss";

import {cs}          from "@Common/react/chain-services";
import {UseState}    from "@Common/react/use-state";
import {formatMoney} from "@Common/ui-components/language/format-money";

export const AppliedCopay = ({appliedCopay, onRemove}) => cs(
    ["removing", (_, next) => UseState({next})],
    ({removing}) => (
        <div className="applied-copay applied-copay-6xm">
            <div className={cx("table", "odd")}>
                <div className="row">
                    <div className="left">
                        <div className="text" xd-qa-type="label" xd-qa-name="Applied Copay">
                            Applied Copay
                        </div>
                        <div className="money" xd-qa-type="text" xd-qa-name="Applied Copay Amount">
                            {formatMoney(appliedCopay.amount)}
                        </div>
                    </div>
                    <div className="right">
                        <a
                            className={cx({disabled: removing.value})}
                            onClick={async () => {
                                if (removing.value) {
                                    return;
                                }
                                removing.onChange(true);
                                await onRemove();
                                removing.onChange(false);
                            }}
                            xd-qa-type="link"
                            xd-qa-name="Remove Copay"
                        >Remove Copay</a>
                    </div>
                </div>
            </div>
        </div>
    ),
);
